export default "__VITE_ASSET__BDk838qG__"